import React, { Component } from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import { loadingStatus, getPayload } from "../../actions"
import Title from "../general/title"
import settings from "settings"
import { Redirect } from "react-router-dom"
import submitData from "../../helpers/submitData"
import * as Yup from "yup"
import { Formik, Field, Form } from "formik"
import Typeahead from "../../components/Typeahead"
import DateField from "../../components/DateField"
import fieldStatus from "../../helpers/fieldStatus"
import cancelFields from "../../models/cancel"
import axios from 'axios'

class EditCancel extends Component {
    constructor(props) {
        super(props)
        this.state = {
            fields: cancelFields
        }
    }

    componentDidMount() {
        this.props.loadingStatus(true)
        // get the sale data
        var data = this.props.match.params
        var userToken = localStorage.getItem("user")

        axios
            .post(settings.ep + "/getSale", data, {
                headers: { Authorization: `Bearer ${userToken}` }
            })
            .then(response => {
                //console.log(response.data)
                this.setState({ fields: response.data, loading: false }, () => {
                    //console.log(this.state)
                })
                this.props.loadingStatus(false)
            })
            .catch(error => {
                // need error handling
                this.props.loadingStatus(false)
            })
    }

    reset = () => {
        this.setState({ redirect: true })
    }

    validation = () => {
        return Yup.object().shape({
            id: Yup.number("Please choose an address from the list.")
                .positive("Please choose an address from the list.")
                .required("Please choose an address from the list."),
            cancel_reason: Yup.string()
                .min(5, "Must be longer than 5 characters")
                .required("Required"),
            cancel_date: Yup.number().required("Required"),
        })
    }

    submitClasses = f => {
        var classNames = require("classnames")
        var submitClasses = classNames("form__submit", {
            "form__submit--ready": f
        })

        return submitClasses
    }

    render() {
        if (this.state.redirect) {
            return <Redirect to={this.state.redirectPath} />
        } else {
            return (
                <div>
                    <Formik
                        initialValues={this.state.fields}
                        validationSchema={this.validation}
                        validateOnMount={true}
                        onSubmit={values => {
                            //this.props.loadingStatus(true)
                            console.log(values)
                            submitData("inputCancel", values).then(data => {
                                this.props.loadingStatus(false)
                                this.setState(
                                    {
                                        redirect: true,
                                        redirectPath: data.redirect,
                                    },
                                    () => {
                                        this.props.getPayload()
                                    }
                                )
                            })
                        }}
                        render={f => (
                            <div className="sales">
                                {console.log(f)}
                                <Title title="Cancels" />
                                <div className="fullCol">
                                    <h3>Edit Cancel : {this.state.fields.label_address}</h3>
                                    <Form>
                                        <ul className="form__list">
                                            <li className={fieldStatus("cancel_reason", f)}>
                                                <label htmlFor="cancel_reason">
                                                    Cancel Reason<sup>*</sup>
                                                </label>
                                                {f.errors.cancel_reason && f.touched.cancel_reason && (
                                                    <div className="form__message">{f.errors.cancel_reason}</div>
                                                )}
                                                <Field name="cancel_reason" type="text" className="form__input" />
                                            </li>
                                            <li className={fieldStatus("cancel_date", f)}>
                                                <label htmlFor="cancel_date">
                                                    Cancel Date <sup>*</sup>
                                                </label>
                                                {f.errors.cancel_date && f.touched.cancel_date && (
                                                    <div className="form__message">{f.errors.cancel_date}</div>
                                                )}
                                                <DateField
                                                    name="cancel_date"
                                                    className="form__textarea"
                                                    value={f.values.cancel_date}
                                                    onChange={f.setFieldValue}
                                                    onBlur={f.setFieldTouched}
                                                    touched={f.touched.cancel_date}
                                                    error={f.errors.cancel_date}
                                                />
                                            </li>
                                        </ul>
                                        <input type="submit" value="Submit" className={this.submitClasses(f.isValid)} />
                                    </Form>
                                </div>
                            </div>
                        )}
                    />
                </div>
            )
        }
    }
}

function mapStateToProps(state) {
    return {
        trafficSources: state.trafficSources,
        payload: state.payload
    }
}

function matchDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            getPayload,
            loadingStatus
        },
        dispatch
    )
}

export default connect(mapStateToProps, matchDispatchToProps)(EditCancel)
